var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9998 9.99976C19.9998 15.5226 15.5226 19.9998 9.99976 19.9998C4.47691 19.9998 -0.000244141 15.5226 -0.000244141 9.99976C-0.000244141 4.47691 4.47691 -0.000244141 9.99976 -0.000244141C15.5226 -0.000244141 19.9998 4.47691 19.9998 9.99976ZM9.49971 13.9997H10.4997C10.7758 13.9997 10.9997 13.7758 10.9997 13.4997V9.49971C10.9997 9.22356 10.7759 8.99971 10.4997 8.99971H9.49971C9.22357 8.99971 8.99971 9.22357 8.99971 9.49971V13.4997C8.99971 13.7758 9.22357 13.9997 9.49971 13.9997ZM9.99966 5.99966C9.44737 5.99966 8.99966 6.44737 8.99966 6.99966C8.99966 7.55194 9.44737 7.99966 9.99966 7.99966C10.5519 7.99966 10.9997 7.55194 10.9997 6.99966C10.9997 6.44737 10.5519 5.99966 9.99966 5.99966Z",
    fill: "#12284A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.7eb664eb558992a09627cab6712bb7ad.svg";
export { ForwardRef as ReactComponent };